import { SIcon } from '@avalara/skylab-sdk/react';
import React from 'react';
const getButtonClasses = (isSelected, disabled) => (isSelected && !disabled
    ? 'secondary active icon-leading'
    : 'secondary');
const SelectPlanButton = ({ isSelected, planName, disableButton }) => (React.createElement("button", { className: getButtonClasses(isSelected, disableButton), "data-ref": `${planName}-option`, disabled: disableButton, "aria-label": `select-${planName}-button` },
    isSelected && !disableButton && React.createElement(SIcon, { name: 'check' }),
    React.createElement("span", null, "Get this plan")));
export default SelectPlanButton;
